import React from "react";

const RemixPollIcon = (props) => (
  <svg
    width="64"
    height="35"
    viewBox="0 0 64 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="64" height="35" rx="17.5" fill="#FAC400" />
    <g clipPath="url(#clip0_poll)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39 8C39.5046 7.99984 39.9906 8.19041 40.3605 8.5335C40.7305 8.87659 40.9572 9.34684 40.995 9.85L41 10V24C41.0002 24.5046 40.8096 24.9906 40.4665 25.3605C40.1234 25.7305 39.6532 25.9572 39.15 25.995L39 26H23C22.4954 26.0002 22.0094 25.8096 21.6395 25.4665C21.2695 25.1234 21.0428 24.6532 21.005 24.15L21 24V19C20.9998 18.4954 21.1904 18.0094 21.5335 17.6395C21.8766 17.2695 22.3468 17.0428 22.85 17.005L23 17H27V15C26.9998 14.4954 27.1904 14.0094 27.5335 13.6395C27.8766 13.2695 28.3468 13.0428 28.85 13.005L29 13H33V10C32.9998 9.49542 33.1904 9.00943 33.5335 8.63945C33.8766 8.26947 34.3468 8.04284 34.85 8.005L35 8H39ZM39 10H35V24H39V10ZM33 15H29V24H33V15ZM27 19H23V24H27V19Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_poll">
        <rect width="24" height="24" fill="white" transform="translate(19 5)" />
      </clipPath>
    </defs>
  </svg>
);

export default RemixPollIcon;
